/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../$$_gendir/node_modules/ng2-completer/components/completer-cmp.ngfactory';
import * as i2 from 'ng2-completer/components/completer-cmp';
import * as i3 from 'ng2-completer/services/completer-service';
import * as i4 from '@angular/forms';
import * as i5 from '@angular/common';
import * as i6 from '../../../app/components/roles-view';
import * as i7 from '@ngrx/store/src/store';
import * as i8 from 'angular2-token';
import * as i9 from '../../../app/reducers/effects/user';
const styles_RolesViewComponent:any[] = ([] as any[]);
export const RenderType_RolesViewComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_RolesViewComponent,data:{}});
function View_RolesViewComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),5,'li',[['class',
      'rv__role']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.clickedRole(_v.context.$implicit)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i0.ɵeld(1,0,(null as any),(null as any),
      4,'dl',([] as any[]),(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵeld(2,0,(null as any),(null as any),1,'dt',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i0.ɵted(3,(null as any),['',''])),(_l()(),i0.ɵeld(4,0,(null as any),(null as any),
      1,'dd',([] as any[]),(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted(5,(null as any),['','']))],(null as any),(_ck,
      _v) => {
    const currVal_0:any = _v.context.$implicit.name;
    _ck(_v,3,0,currVal_0);
    const currVal_1:any = _v.context.$implicit.code;
    _ck(_v,5,0,currVal_1);
  });
}
function View_RolesViewComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'div',[['class',
      'rv__no-active-role']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted(-1,(null as any),['Select a role on the left to adjust user-role assignment']))],
      (null as any),(null as any));
}
function View_RolesViewComponent_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),4,'li',[['class',
      'rv__role-user']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(1,0,(null as any),(null as any),3,'label',[['class','rv__ru-email']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(2,(null as any),['',''])),(_l()(),i0.ɵeld(3,0,(null as any),
          (null as any),1,'button',[['class','rv__ru-btn-remove tiny']],(null as any),
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.clickedRemoveUserFromRole(_v.context.$implicit)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['Remove']))],
      (null as any),(_ck,_v) => {
        const currVal_0:any = _v.context.$implicit.email;
        _ck(_v,2,0,currVal_0);
      });
}
function View_RolesViewComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),26,'div',[['class',
      'rv__active-role']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵeld(1,0,(null as any),(null as any),1,'h3',[['class',
      'rv__subheader']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(2,(null as any),['Users with: ',''])),(_l()(),i0.ɵeld(3,0,(null as any),
          (null as any),20,'div',[['class','rv__add-user-wrapper']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵeld(4,
          0,(null as any),(null as any),19,'div',[['class','rv__add-user']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵeld(5,
          0,(null as any),(null as any),10,'div',[['class','input-row']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵeld(6,
          0,(null as any),(null as any),9,'div',[['class','input-group full']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵeld(7,
          0,(null as any),(null as any),8,'div',[['class','ig__content-wrapper']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(8,0,(null as any),(null as any),5,'ng2-completer',[['id','search-by-email'],
          ['name','search-by-email']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
          (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
          [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
              (null as any)]],[[(null as any),'ngModelChange'],[(null as any),'selected']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('ngModelChange' === en)) {
              const pd_0:any = ((<any>(_co.emailSearchStr = $event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
              const pd_1:any = ((<any>_co.selectedUserToAdd($event)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i1.View_CompleterCmp_0,i1.RenderType_CompleterCmp)),i0.ɵdid(9,12697600,
          (null as any),0,i2.CompleterCmp,[i3.CompleterService,i0.ChangeDetectorRef],
          {pause:[0,'pause'],minSearchLength:[1,'minSearchLength'],openOnFocus:[2,
              'openOnFocus'],datasource:[3,'datasource']},{selected:'selected'}),i0.ɵprd(1024,
          (null as any),i4.NG_VALUE_ACCESSOR,(p0_0:any) => {
            return [p0_0];
          },[i2.CompleterCmp]),i0.ɵdid(11,671744,(null as any),0,i4.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i4.NG_VALUE_ACCESSOR]],{name:[0,'name'],
          model:[1,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,(null as any),
          i4.NgControl,(null as any),[i4.NgModel]),i0.ɵdid(13,16384,(null as any),
          0,i4.NgControlStatus,[i4.NgControl],(null as any),(null as any)),(_l()(),
          i0.ɵeld(14,0,(null as any),(null as any),1,'label',[['for','search-by-email']],
              (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['Add by User email'])),(_l()(),i0.ɵeld(16,
          0,(null as any),(null as any),7,'div',[['class','actions']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵeld(17,
          0,(null as any),(null as any),6,'div',[['class','input-row']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵeld(18,
          0,(null as any),(null as any),5,'div',[['class','input-group']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵeld(19,
          0,(null as any),(null as any),4,'div',[['class','ig__content-wrapper']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(20,0,(null as any),(null as any),3,'button',[['class','tiny']],
          (null as any),[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.clickedAddUser()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(21,278528,(null as any),0,i5.NgClass,
          [i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{klass:[0,
              'klass'],ngClass:[1,'ngClass']},(null as any)),i0.ɵpod(22,{'disabled':0}),
      (_l()(),i0.ɵted(-1,(null as any),['Add'])),(_l()(),i0.ɵeld(24,0,(null as any),
          (null as any),2,'ul',[['class','rv__role-users']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_RolesViewComponent_4)),i0.ɵdid(26,802816,
          (null as any),0,i5.NgForOf,[i0.ViewContainerRef,i0.TemplateRef,i0.IterableDiffers],
          {ngForOf:[0,'ngForOf']},(null as any))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_8:any = 500;
    const currVal_9:any = 0;
    const currVal_10:any = true;
    const currVal_11:any = _co.emailCompleter;
    _ck(_v,9,0,currVal_8,currVal_9,currVal_10,currVal_11);
    const currVal_12:any = 'search-by-email';
    const currVal_13:any = _co.emailSearchStr;
    _ck(_v,11,0,currVal_12,currVal_13);
    const currVal_14:any = 'tiny';
    const currVal_15:any = _ck(_v,22,0,!_co.selectedUser);
    _ck(_v,21,0,currVal_14,currVal_15);
    const currVal_16:any = _co.roleUsers;
    _ck(_v,26,0,currVal_16);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.activeRole.name;
    _ck(_v,2,0,currVal_0);
    const currVal_1:any = i0.ɵnov(_v,13).ngClassUntouched;
    const currVal_2:any = i0.ɵnov(_v,13).ngClassTouched;
    const currVal_3:any = i0.ɵnov(_v,13).ngClassPristine;
    const currVal_4:any = i0.ɵnov(_v,13).ngClassDirty;
    const currVal_5:any = i0.ɵnov(_v,13).ngClassValid;
    const currVal_6:any = i0.ɵnov(_v,13).ngClassInvalid;
    const currVal_7:any = i0.ɵnov(_v,13).ngClassPending;
    _ck(_v,8,0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
export function View_RolesViewComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),12,'div',[['class',
      'roles-view']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(1,0,(null as any),(null as any),1,'h1',[['class','rv__header']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['Roles and policies'])),(_l()(),i0.ɵeld(3,
          0,(null as any),(null as any),9,'div',[['class','rv__content-wrapper']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(4,0,(null as any),(null as any),3,'div',[['class','rv__roles-wrapper']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(5,0,(null as any),(null as any),2,'ul',[['class','rv__roles']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_RolesViewComponent_1)),
      i0.ɵdid(7,802816,(null as any),0,i5.NgForOf,[i0.ViewContainerRef,i0.TemplateRef,
          i0.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i0.ɵeld(8,
          0,(null as any),(null as any),4,'div',[['class','rv__active-role-wrapper']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_RolesViewComponent_2)),
      i0.ɵdid(10,16384,(null as any),0,i5.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_RolesViewComponent_3)),i0.ɵdid(12,16384,
          (null as any),0,i5.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any))],(_ck,_v) => {
    var _co:i6.RolesViewComponent = _v.component;
    const currVal_0:any = _co.roles;
    _ck(_v,7,0,currVal_0);
    const currVal_1:boolean = !_co.activeRole;
    _ck(_v,10,0,currVal_1);
    const currVal_2:any = _co.activeRole;
    _ck(_v,12,0,currVal_2);
  },(null as any));
}
export function View_RolesViewComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'roles-view',
      ([] as any[]),(null as any),(null as any),(null as any),View_RolesViewComponent_0,
      RenderType_RolesViewComponent)),i0.ɵdid(1,245760,(null as any),0,i6.RolesViewComponent,
      [i7.Store,i3.CompleterService,i8.Angular2TokenService,i9.UserEffects],(null as any),
      (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const RolesViewComponentNgFactory:i0.ComponentFactory<i6.RolesViewComponent> = i0.ɵccf('roles-view',
    i6.RolesViewComponent,View_RolesViewComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/$$_gendir/app/components/roles-view.ngfactory.ts